import { render } from "./CallChatBot.vue?vue&type=template&id=c7752a58&ts=true"
import script from "./CallChatBot.vue?vue&type=script&lang=ts&setup=true"
export * from "./CallChatBot.vue?vue&type=script&lang=ts&setup=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/pages/call/components/CallChatBot.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "c7752a58"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('c7752a58', __exports__)) {
    api.reload('c7752a58', __exports__)
  }
  
  module.hot.accept("./CallChatBot.vue?vue&type=template&id=c7752a58&ts=true", () => {
    api.rerender('c7752a58', render)
  })

}


export default __exports__